import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { mediaQuery } from '@tcp/core/styles/themes/TCP/mediaQuery';
import colors from '@tcp/core/styles/themes/TCP/colors';
import {
  applyAspectRatioBoxInsideStyles,
  applyAspectRatioBoxStyles,
} from '@tcp/core/src/utils/utils.web';
import Modal from '../../molecules/Modal/view/Modal';

const getStyleWithAspectRatio = (aspectRatioObj, variation) => {
  const { aspectRatioD, aspectRatioT, aspectRatioM } = !isEmpty(aspectRatioObj) && aspectRatioObj;
  if (variation === 'MOBILE' && aspectRatioM) {
    return `position: inherit;`;
  }
  if (variation === 'TABLET' && aspectRatioT) {
    return `position: inherit;`;
  }
  if (variation === 'DESKTOP' && aspectRatioD) {
    return `position: inherit;`;
  }
  return `position: relative;`;
};

export const StyledImage = styled.img`
  ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'DESKTOP')}
  }
  ${(props) => props.overrideStyle || ''}
`;

export const StyledVideo = styled.div`
  ${(props) => getStyleWithAspectRatio(props?.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props?.theme?.mediaQuery?.medium} {
    ${(props) => getStyleWithAspectRatio(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props?.theme?.mediaQuery?.large} {
    ${(props) => getStyleWithAspectRatio(props?.aspectRatioObj, 'DESKTOP')}
  }
  ${(props) =>
    props.makePositionAbsolute
      ? `${applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'MOBILE')}
  @media ${props.theme.mediaQuery.medium} {
    ${applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${props.theme.mediaQuery.large} {
    ${applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'DESKTOP')}
  }`
      : ``}

  width: 100%;
  ${(props) =>
    props.onScrollIdentifier
      ? `
  position: sticky;
  height: 80vh;
  top: 0;
  `
      : `
  height: 100%;
  `}
  video {
    width: 100% !important;
    height: inherit;
    object-fit: fill;
    ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'MOBILE')}
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'TABLET')}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => applyAspectRatioBoxInsideStyles(props?.aspectRatioObj, 'DESKTOP')}
    }
    ${(props) => props.overrideStyle || ''}
  }
  .video-play-button {
    position: absolute;
    bottom: 16px;
    z-index: 10;
    ${(props) =>
      props.isModule
        ? `
      left: 8px;
      @media only screen and (min-width: 768px) {
          left: 16px;
      }
      background-color: transparent;
      height: 40px;
      width: 40px;
      border: 0;
    `
        : `
      left: 50%;
      transform: translate(-50%, 0);
      background: transparent;
      height: 28px;
      width: 28px;
      border: 0;
    `}
    padding: 0;
    cursor: pointer;
  }

  .video-mute-btn {
    position: absolute;
    bottom: 16px;
    z-index: 10;
    left: 42px;
    @media only screen and (min-width: 768px) {
      left: 52px;
    }
    background-color: transparent;
    height: 40px;
    width: 40px;
    border: 0;
    cursor: pointer;
  }

  .big-video-play-btn {
    position: absolute;
    left: 50%;
    bottom: 50%;
    transform: translate(-50%, 50%);
    background: ${colors.PRIMARY.PALEGRAY};
    height: 100px;
    width: 100px;
    border-radius: 50%;
    border: 0;
    padding: 0;
    padding-left: 10px;
    opacity: 50%;
    cursor: pointer;
  }

  ${(props) =>
    props.isNativeVideoPlayer ? `${!props.videoLoaded ? `display: none;` : `display: block;`}` : ``}
`;

export const StyledModal = styled(Modal)`
  .plp_pop_up_media_modal {
    .TCPModal__InnerContent {
      padding: 22px;
      height: auto;
      @media ${(props) => props.theme.mediaQuery.medium} {
        padding: 24px;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        padding: 36px;
      }
    }
    .alignTop {
      top: 0px;
      right: 5px;
      width: 10px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        top: 0px;
        right: 6px;
      }
      @media ${(props) => props.theme.mediaQuery.large} {
        top: 12px;
        right: 16px;
      }
    }
  }
`;

export const StyledModuleWrapper = styled.div`
  width: 100%;
  ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxStyles(props?.aspectRatioObj, 'DESKTOP')}
  }
`;

export const getImageStyle = (imgData) => {
  const {
    width_d: widthD,
    width_t: widthT,
    width_m: widthM,
    height_d: heightD,
    height_t: heightT,
    height_m: heightM,
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
  } = imgData || {};
  return `
    ${widthM ? `width: ${widthM}px !important;` : ''}
    ${heightM ? `height: ${heightM}px !important;` : ''}
    ${borderBottomLeftRadius ? `border-bottom-left-radius: ${borderBottomLeftRadius}px;` : ''}
    ${borderBottomRightRadius ? `border-bottom-right-radius: ${borderBottomRightRadius}px;` : ''}
    ${borderTopLeftRadius ? `border-top-left-radius: ${borderTopLeftRadius}px;` : ''}
    ${borderTopRightRadius ? `border-top-right-radius: ${borderTopRightRadius}px;` : ''}
    @media ${mediaQuery && mediaQuery.medium} {
      ${widthT ? `width: ${widthT}px !important;` : ''}
      ${heightT ? `height: ${heightT}px !important;` : ''}
    }
    @media ${mediaQuery && mediaQuery.large} {
      ${widthD ? `width: ${widthD}px !important;` : ''}
      ${heightD ? `height: ${heightD}px !important;` : ''}
    }
  `;
};

export const getVideoStyle = (videoData) => {
  const {
    height_d: heightD,
    height_t: heightT,
    height_m: heightM,
    borderBottomLeftRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
  } = videoData || {};
  return `
    min-height: 100%;
    ${heightM ? `height: ${heightM}vw !important;` : ''}
    ${
      borderBottomLeftRadius
        ? `border-bottom-left-radius: ${borderBottomLeftRadius}px !important;`
        : ''
    }
    ${
      borderBottomRightRadius
        ? `border-bottom-right-radius: ${borderBottomRightRadius}px !important;`
        : ''
    }
    ${borderTopLeftRadius ? `border-top-left-radius: ${borderTopLeftRadius}px !important;` : ''}
    ${borderTopRightRadius ? `border-top-right-radius: ${borderTopRightRadius}px !important;` : ''}
    @media ${mediaQuery.medium} {
      ${heightT ? `height: ${heightT}vw !important;` : ''}

    }
    @media ${mediaQuery.large} {
      ${heightD ? `height: ${heightD}vw !important;` : ''}
    }
  `;
};

export const StyledFigureTag = styled.figure`
  ${(props) => getStyleWithAspectRatio(props?.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props?.theme?.mediaQuery?.medium} {
    ${(props) => getStyleWithAspectRatio(props?.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props?.theme?.mediaQuery?.large} {
    ${(props) => getStyleWithAspectRatio(props?.aspectRatioObj, 'DESKTOP')}
  }
  text-align: center;
  color: ${(props) => props.theme.colors.WHITE};
`;

export const StyledFigCaption = styled.figcaption`
  width: 100%;
  background: #afa8a8d9;
  padding: 6px 0;
  font-size: 20px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 50%);
  -webkit-transform: translate(-50%, 50%);
  -moz-transform: translate(-50%, 50%);
  -ms-transform: translate(-50%, 50%);
`;

export const StyledVideoContainer = styled.div`
  ${(props) => (!props.videoLoaded ? `display: none;` : `display:block;`)}

  ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'DESKTOP')}
  }

  .vjs-fluid:not(.vjs-audio-only-mode) {
    height: 100%;
  }

  .cld-video-player {
    padding-top: inherit !important;
  }
`;

export const StyledImageContainer = styled.div`
  ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'MOBILE')}
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'TABLET')}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => applyAspectRatioBoxInsideStyles(props.aspectRatioObj, 'DESKTOP')}
  }
`;
